import { ReactNode } from "react";
import {
  AlertColor,
  DialogTitle as MUIDialogTitle,
  DialogTitleProps,
  styled,
} from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export type DialogProps = {
  children: ReactNode;
  severity?: AlertColor;
};

const DialogTitleContainer = styled(
  ({
    severity,
    ...props
  }: DialogTitleProps & Pick<DialogProps, "severity">) => (
    <MUIDialogTitle {...props} />
  )
)(({ theme, severity }) => [
  {
    "&.MuiDialogTitle-root": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      columnGap: theme.spacing(2),
    },
  },
  severity && {
    "&.MuiDialogTitle-root": {
      color: theme.palette[severity].main,
    },
  },
]);

const DialogTitle = (props: DialogProps) => {
  const { severity } = props;

  const computeTitle = () => {
    switch (severity) {
      case "error":
        return <ErrorOutlineRoundedIcon />;
      case "info":
        return <InfoOutlinedIcon />;
      default:
        return;
    }
  };

  return (
    <DialogTitleContainer
      severity={severity}
      data-testid="confirm-dialog-title"
    >
      {computeTitle()}
      {props.children}
    </DialogTitleContainer>
  );
};

export default DialogTitle;
